<template>
  <div
    class="block cursor-text px-4 py-2 sm:px-6 sm:py-2 m-0 border-0"
    :class="{
      'text-gray-800': p(),
      'bg-gray-100 text-gray-800 italic': b(),
      'bg-gray-200 text-gray-900 font-medium': m(),
      'bg-gray-200 text-gray-900 font-medium italic': bm(),
      'line-through text-gray-700': pd(),
      'line-through bg-gray-100 text-gray-700 italic': bd(),
      'line-through bg-gray-200 text-gray-700 font-medium': md(),
      'line-through bg-gray-200 text-gray-700 font-medium italic': bmd(),
    }"
  >
    <!-- <label class="inline-flex items-center"></label> -->
    <div class="flex items-center">
      <!-- checkbox -->
      <label aria-label="Toggle Completion">
        <input type="checkbox" class="form-checkbox text-gray-600 border-gray-400 focus:shadow-outline-gray focus:border-gray-400" :class="textSizeClass" @change="toggleCompletion" :checked="isDone">
      </label>

      <!-- description -->
      <span ref="description"
        @keydown.delete="drop" @keydown.enter="enter" @keydown.down="down" @keydown.up="up"
        @input="change"
        class="un ml-2 focus:outline-none flex-grow"
        :class="textSizeClass"
        contenteditable
        v-text="description">
      </span>

      <!-- priority -->
      <button v-if="shit.description"
        aria-label="Toggle Priority"
        @click="togglePriority"
        class="hover:bg-gray-200 focus:outline-none focus:shadow-outline-gray focus:bg-gray-400 rounded-full inline-flex items-center p-1" >
        <svg
          :class="{
            'stroke-current text-gray-400': p(),
            'stroke-current text-gray-300': pd(),
            'stroke-current stroke-2 text-gray-600': isShitScheduledToday && !isMit,
            'fill-current text-gray-400': isBigRock,
            'fill-current text-gray-600': isMit
          }"
          class="w-4 h-4 feather feather-star" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      </button>

      <!-- shit view -->
      <!-- <button v-if="selectable && shit.description"
        @click="select"
        class="hover:bg-gray-200 focus:outline-none focus:shadow-outline focus:bg-gray-200 rounded-full inline-flex items-center p-1"
      >
        <svg :class="{ 'text-gray-300': isDone, 'text-gray-500': !isDone }" class="stroke-current feather feather-chevron-right w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button> -->

      <!-- record -->
      <div v-if="!shit.description">
        <button
          aria-label="Speech to Text"
          @click="listen"
          class="hover:bg-gray-200 focus:outline-none focus:shadow-outline focus:bg-gray-200 rounded-full inline-flex items-center p-1"
          :class="{ 'bg-red-6 shadow-outline': isListening }"
        >
          <svg class="fill-current w-4 h-4" :class="{'text-red-6 bg-red-6 rounded-full': isListening }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9 18v-1.06A8 8 0 0 1 2 9h2a6 6 0 1 0 12 0h2a8 8 0 0 1-7 7.94V18h3v2H6v-2h3zM6 4a4 4 0 1 1 8 0v5a4 4 0 1 1-8 0V4z"/></svg>
        </button>
      </div>
    </div>

    <!-- debug view -->
    <div v-if="isDebug" class="overflow-x-auto text-gray-700 text-xs">{{ meta }}</div>
    <!-- detailed view -->
    <div v-if="isDetailedView" class="ml-4">
      <span
        class="text-sm text-gray-700 rounded-full bg-gray-200 px-2 pb-1 mr-1"
        v-for="meta in metas" :key="meta"
      >
        {{ meta }}
      </span>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import shit from '../mixins/shit'
import debounce from 'debounce'
import { doShitRepeats, parseShitMetas, getAllShitMetas } from '../constants/shit-functions'
import { repeatNexts } from '../constants/shit-repeat-types'
import { viewTypes } from '../constants/shit-view-types'
import { actionTypes, actionTriggers } from '../constants/shit-action-types'

export default {
  mixins: [shit],
  props: {
    shit: {
      type: Object,
      required: true
    },
    // @todo this is weak impl, we must update this
    selectable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      description: this.shit.description,
      isListening: false,
      change: debounce(() => {
        this.update()
      }, 700),
      metas: getAllShitMetas(this.shit)
    }
  },
  computed: {
    ...mapGetters('filters', ['view']),
    meta () {
      return JSON.stringify(this.shit)
    },
    isDebug () {
      return this.view === viewTypes.VIEW_DEBUG
    },
    isDetailedView () {
      return this.view === viewTypes.VIEW_DETAILED
    },
    textSizeClass () {
      return { [this.$store.state.settings.textSize]: true }
    }
  },
  methods: {
    ...mapActions(['syncShit', 'deleteShit', 'insertEmptyShitAfter']),
    // start: crud
    toggleCompletion () {
      const newCompletedAt = this.isDone ? null : new Date()
      const updates = { uuid: this.shit.uuid, completedAt: newCompletedAt }
      this.syncShit(updates)

      if (newCompletedAt && doShitRepeats(this.shit)) {
        this.scheduleNextShit(this.shit)
      }
    },
    scheduleNextShit (shit) {
      const repeat = repeatNexts[shit.scheduledAt.repeat]
      if (!repeat) {
        alert(`Repeat ${shit.scheduledAt.repeat} from ${shit.uuid} not supported.`)
        return
      }

      /*
      schedule me tomorrow
        tomorrow, 3/18, null
      schedule me 3/19
        3/19, 3/19, null
      */
      // update the text with the new schedule
      const scheduledAt = JSON.parse(JSON.stringify(shit.scheduledAt))

      scheduledAt.start = repeat(Date.parse(scheduledAt.start))
      scheduledAt.end = scheduledAt.end ? repeat(Date.parse(scheduledAt.end)) : null

      const options = { weekday: 'long', month: 'long', day: 'numeric' }
      if ('hour' in scheduledAt.parse.knownValues) {
        options.hour = 'numeric'
      }
      if ('minute' in scheduledAt.parse.knownValues && scheduledAt.parse.knownValues.minute) {
        options.minute = 'numeric'
      }
      const formatter = new Intl.DateTimeFormat(undefined, options)
      const text = scheduledAt.end ? formatter.formatRange(scheduledAt.start, scheduledAt.end) : formatter.format(scheduledAt.start)
      scheduledAt.parse.text = text

      // @todo get helper methods for nested props
      let description = shit.description
      if (shit.scheduledAt.parse.text) {
        description = description.replace(shit.scheduledAt.parse.text, text)
      } else {
        description = `${description} ${text}`
      }

      this.insertEmptyShitAfter(shit).then(newShit => {
        const { uuid, createdAt, updatedAt, completedAt } = newShit
        let updates = {}
        updates = Object.assign(updates, newShit)
        updates = Object.assign(updates, shit)
        updates = Object.assign(updates, { uuid, createdAt, updatedAt, completedAt, scheduledAt, description })
        this.syncShit(updates)
      })
    },
    drop () {
      const newDescription = this.$refs.description.innerText
      if (newDescription) {
        return
      }

      this.up()
      this.deleteShit(this.shit)
    },
    update () {
      console.warn('update', this.shit.description)
      // @todo
      if (!this.$refs.description) {
        return
      }

      const newDescription = this.$refs.description.innerText
      if (!this.shit || (newDescription === this.shit.description)) {
        return
      }

      const updates = parseShitMetas(newDescription)
      updates.description = newDescription
      updates.updatedAt = new Date()
      updates.uuid = this.shit.uuid

      if (updates.action) {
        actionTriggers[updates.action](updates)
      }

      this.syncShit(updates)
    },
    // end: crud
    // start: priority
    togglePriority () {
      // pebble, mit, rock
      if (this.isBigRock) {
        this.$store.commit('toggleBigRock', this.shit)
      } else if (this.isMit) {
        this.$store.commit('toggleMit', this.shit)
        this.$store.commit('toggleBigRock', this.shit)
      } else {
        this.$store.commit('toggleMit', this.shit)
      }

      const updates = {
        uuid: this.shit.uuid,
        action: actionTypes.ACTION_NEXT
      }
      this.syncShit(updates)
    },
    // end: priority
    // start: nav
    select () {
      this.$emit('select', this.shit)
    },
    up () {
      this.$emit('up', this.shit)
    },
    enter (e) {
      e.preventDefault()
      this.$emit('enter', this.shit)
    },
    down (e) {
      e.preventDefault()
      this.$emit('down', this.shit)
    },
    focus () {
      this.$refs.description.focus()
    },
    // end: nav
    // start: speech recognition
    listen () {
      if (!('webkitSpeechRecognition' in window)) {
        // @todo don't show the mic instead
        alert('Unfortunately, your device does not support Web Speech API.')
        return
      }

      const SpeechRecognition = window.webkitSpeechRecognition
      const recognition = new SpeechRecognition()
      recognition.continuous = false
      recognition.interimResults = false
      recognition.lang = 'en-US'

      let transcript = ''

      recognition.onstart = (e) => {
        this.isListening = true
      }

      recognition.onresult = (e) => {
        for (let i = e.resultIndex; i < e.results.length; ++i) {
          if (e.results[i].isFinal) {
            transcript += e.results[i][0].transcript
          }
        }

        this.$refs.description.innerText = transcript
      }

      recognition.onerror = (e) => {
        this.isListening = false
      }

      recognition.onend = (e) => {
        this.isListening = false
        this.$refs.description.focus()
        this.$refs.description.blur()
      }

      recognition.start()
    },
    // end: speech recognition
    // start: highlighting
    p () {
      return !this.isBigRock && !this.isMit && !this.isDone
    },
    pd () {
      return !this.isBigRock && !this.isMit && this.isDone
    },
    b () {
      return this.isBigRock & !this.isMit && !this.isDone
    },
    bm () {
      return this.isBigRock && this.isMit && !this.isDone
    },
    m () {
      return !this.isBigRock && this.isMit && !this.isDone
    },
    md () {
      return !this.isBigRock && this.isMit && this.isDone
    },
    bmd () {
      return this.isBigRock && this.isMit && this.isDone
    },
    bd () {
      return this.isBigRock && !this.isMit && this.isDone
    }
    // end: highlighting
  }
}
</script>
